<template>
  <div class="electricity px">
    <div class="item">
      <div class="name">
        {{ $t("mouse.name") }}
      </div>
      <div class="battery" :class="{ charging: mouseBatStatus === 1 }">
        <div class="line" v-if="mousePercent === -1"></div>
        <div class="percentage" v-for="i in mouseNum" :key="i"></div>
      </div>
      <i class="iconfont icondian" v-if="mouseBatStatus == 1" />
    </div>
    <div class="item" v-if="$route.path.includes('/dongle-mouse')">
      <div class="name">
        Dongle
      </div>
      <div class="battery" :class="{ charging: mouseDBatStatus === 1 }">
        <div class="line" v-if="mouseDPercent === -1"></div>
        <div class="percentage" v-for="i in mouseDNum" :key="i"></div>
      </div>
      <i class="iconfont icondian" v-if="mouseDBatStatus === 1" />
    </div>
  </div>
</template>
<script>
export default {
  name: "CMouseElectricity",
  data() {
    return {
      mousePercent: 0, // 鼠标电量 范围:0-100
      mouseDPercent: 0, // 鼠标dongle电量 范围:0-100
      mouseBatStatus: 0, // 鼠标电池状态 范围:0未充电 1充电中 2充满
      mouseDBatStatus: 0, // 鼠标dongle电池状态 范围: 0未充电 1充电中 2充满
      mouseOnline: 1, // 鼠标是否在线: 1:在线，0:掉线
      timer: 0,
    };
  },
  computed: {
    mouseNum() {
      if (this.mousePercent <= 0) {
        return 0;
      } else {
        return Math.ceil(this.mousePercent / 25);
      }
    },
    mouseDNum() {
      if (this.mouseDPercent <= 0) {
        return 0;
      } else {
        return Math.ceil(this.mouseDPercent / 25);
      }
    },
  },
  mounted() {
    this.$store.dispatch("loader/getElectricity");
    window.updateElectricity = (json) => {
      if (json) {
        console.log("updateElectricity", json);
        const data = JSON.parse(json);
        let time = 5 * 1000;
        if (!data) {
          return;
        }
        this.mousePercent = data.mousePercent;
        this.mouseDPercent = data.mouseDPercent;
        this.mouseBatStatus = data.mouseBatStatus;
        this.mouseDBatStatus = data.mouseDBatStatus;
        if (data.mouseOnline == 0) {
          clearTimeout(this.timer);
          this.$store.dispatch("loader/setLoading", true);
          this.$info({
            title: this.$t("mouse.offline"),
            okText: this.$t("yes"),
            centered: true,
            onOk: () => {
              this.$store.dispatch("loader/setLoading", false);
              this.$router.replace(this.$paths.deviceList);
            },
          });
          return;
        }
        if (data.mouseLoading == 1) {
          time = 1000;
        }
        this.timer = setTimeout(() => {
          this.$store.dispatch("loader/getElectricity");
        }, time);
        console.log("updateElectricity", "true");
      }
    };
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.electricity.px {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  z-index: 2;
  top: 20px;
  right: 20px;

  .item {
    @include flex-center;
    width: 140px;
    justify-content: flex-start;
    margin-bottom: 5px;

    .name {
      width: 80px;
      text-align: right;
      font-size: 14px;
    }

    .battery {
      @include flex-center;
      justify-content: flex-start;
      width: 31px;
      height: 18px;
      background: url("../../../assets/images/icon_battery.svg") center / 100%
        auto no-repeat;
      position: relative;
      margin: 0 2px 0 8px;
      padding: 3px 0 3px 4px;
      flex: none;

      .percentage {
        height: 10px;
        width: 4px;
        margin-right: 2px;
        border-radius: 1px;
        background-color: $primary-color;
        flex: none;
      }

      &.charging .percentage:last-child {
        animation: chargingChange 2s infinite linear;
      }

      .line {
        height: 150%;
        border-left: 0.03rem solid $primary-color;
        border-right: 0.03rem solid #171717;
        transform: rotate(-30deg);
        position: absolute;
        left: 45%;
        top: -25%;
      }
    }

    .iconfont {
      color: $primary-color;
      animation: colorChange 2s infinite linear;
      font-size: 12px;
    }
  }
}
@keyframes colorChange {
  0% {
    color: $primary-color;
  }

  50% {
    color: greenyellow;
  }

  100% {
    color: $primary-color;
  }
}

@keyframes chargingChange {
  0% {
    background-color: #171717;
  }

  50% {
    background-color: $primary-color;
  }

  100% {
    background-color: #171717;
  }
}
</style>
